import { FC, PropsWithChildren } from 'react';
import PtiLayoutHeader from './pti-layout-header';

const PtiLayout:FC<PropsWithChildren> = ({children}) => {
  return <div>
    <PtiLayoutHeader />
    {children}
  </div>;
};

export default PtiLayout;